import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";
import { DatasheetFormatListDto } from "@common/dto/format/datasheet-list-dto";

export type GetDatasheetFolderFormats = {
  folderId: FolderPrimaryListDto["id"];
};

export const getDatasheetResultFolderFormats = (
  params: GetDatasheetFolderFormats
): Promise<Array<DatasheetFormatListDto>> => {
  return Promise.resolve([
    { id: 1, name: "CORE - Full Risk Assessment" },
    { id: 2, name: "CORE - FHQ Email Invitation" },
    { id: 3, name: "CORE - Relative Template" },
    { id: 4, name: "CORE - Full Risk Assessment Spanish" },
    { id: 5, name: "CORE - CTRA Template" },
    { id: 6, name: "CORE - CTRA Relative Template" },
    { id: 7, name: "CORE - CTRA Relative Template Spanish" },
    { id: 8, name: "CORE - CTRA Template Spanish" },
    { id: 9, name: "CORE - CTRA Template Spanish 2" },
    { id: 10, name: "CORE - CTRA Template Spanish 3" },
  ] as Array<DatasheetFormatListDto>);
};
